<template>
  <div style="margin-top: -13px">
    <v-container fluid>
      <v-card elevation="0">
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card
                class="mx-5 mt-5 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  label="Digite seu pin"
                  class="purple-input"
                  v-model="actualPassword"
                  :rules="pwdRules"
                  required
                  :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="mt-n8 mx-5">
              <v-btn
                class="mx-0 font-weight-light"
                color="primary"
                text
                @click="upPinOrCreate"
              >
                Actualizar ou Criar Pin
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import eventBus from "@/main";

import convertToB64 from "../../../../../services/convertToB64";

export default {
  name: "UpdatePinEnterprise",
  data: () => ({
    actualPassword: "",
    valid: true,
    value: true,
    pwdRules: [
      v => !!v || "Pin é obrigatório",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter"
    ]
  }),
  methods: {
    upPinOrCreate() {
      if (this.$refs.form.validate()) {
        let encryptedPass = convertToB64.toRsa(this.actualPassword);
        let pwd = {
          pin: encryptedPass,
          key: ""
        };
        this.$store.dispatch("updateAndCreateEPin", pwd);
      }
    }
  }
};
</script>

<style scoped></style>
